import axios from '../../config/axios.js'
import store from '../../vuex/store.js'

const STATE = {

    comments: []

}

const GETTERS = {

    comments: state => state.comments

}

const MUTATIONS = {

    getComments(state, comments) {
        state.comments = comments
    }

}

const ACTIONS = {

    async writeComment({ dispatch }, payload) {
        await axios.ACCESS.post('/api/s2/project/' + parseInt(payload.proj_id) + '/comment', {
                'comment': payload.comment,
                'private': payload.private
            })
            .then(async(res) => {
                // console.log('comments/writeComment', res)
                dispatch('getComments', payload.proj_id)
            })
    },

    async modifyComment({ dispatch }, payload) {
        // comment : optional, str
        // private : optional, boolean. default false, checking true is definite
        // status : option, int. 0: open, 1: hide, 2: hide from all
        await axios.ACCESS.patch('/api/s2/project/' + parseInt(payload.proj_id) + '/comment/' + parseInt(payload.comment_id), {
                'comment': payload.comment,
                'private': payload.private,
            })
            .then(async(res) => {
                // console.log('comments/modifyComment', res)
                dispatch('getComments', payload.proj_id)
            })
    },

    async changeStatus({ dispatch }, payload) {
        // console.log('status', payload.status)
        await axios.ACCESS.patch('/api/s2/project/' + parseInt(payload.proj_id) + '/comment/' + parseInt(payload.comment_id), {
                'status': payload.status,
            })
            .then(async(res) => {

                // console.log('comments/modifyComment', res)
                dispatch('getComments', payload.proj_id)
            })
    },

    async deleteComment({ dispatch }, payload) {
        await axios.ACCESS.delete('/api/s2/project/' + parseInt(payload.proj_id) + '/comment/' + parseInt(payload.comment_id))
            .then(async(res) => {
                // console.log("comments/deleteComment", res)
                dispatch('getComments', payload.proj_id)
            })
    },

    async getComments({ commit }, proj_id) {
        await axios.ACCESS.get('/api/s2/project/' + parseInt(proj_id) + '/comments')
            .then(async(res) => {
                // console.log("comments/getComments", res)
                commit('getComments', res.data.comments)
            })
    },

}

export default {
    namespaced: true,
    state: STATE,
    getters: GETTERS,
    mutations: MUTATIONS,
    actions: ACTIONS,
}


// WEBPACK FOOTER //
// ./src/vuex/modules/comments.js